import { Fragment } from 'react'
import { BRAND_TWITTER } from 'shared/constants'
import { ComposerTwitterPost, TweetType } from 'shared/types'
import { ComposerTwitterPostOptions } from 'components/Composer/CustomizePostBlock/ComposerTwitterPostOptions'
import styles from '../BulkPost.pcss'
import { BulkNetworkOptionsProps } from './types'

export function TwitterBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, recycleSelector } = props

  const onTweetTypeChange = (type: TweetType) => {
    props.onTweetTypeChange(post.id, type)
  }

  return (
    <Fragment>
      {post.content?.feed?.type === BRAND_TWITTER && (
        <ComposerTwitterPostOptions
          post={post.data as ComposerTwitterPost}
          content={post.content}
          className={styles.option}
          onApplyToAll={props.onApplyTweetTypeToAll}
          onSelectionChange={onTweetTypeChange}
        />
      )}
      <div className={styles.option}>{recycleSelector}</div>
    </Fragment>
  )
}
